import { DEFAULT_VIDEO_VOLUME, useVideoVolumn } from "helpers/useVideoVolumn";
import { VolumeHigh, VolumeOff } from "mdi-material-ui";
import React from "react";

import PlayerButton from "./PlayerButton";

// Mute toggle for touch screens, where the device's buttons set the volume
export default function MuteButton({ color }) {
  const [volume, volumeSet] = useVideoVolumn();
  const muted = volume === 0;

  return (
    <PlayerButton
      title={muted ? "Unmute" : "Mute"}
      color={color}
      onClick={() => volumeSet(volume === 0 ? DEFAULT_VIDEO_VOLUME : 0)}
      icon={muted ? <VolumeOff /> : <VolumeHigh />}
    />
  );
}
